import { NotFound, HasUnsavedChangesProvider, InjectorProvider } from '@ami/react/core';
import { createBrowserHistory } from 'history';
import { Fragment } from 'react';
import ReactAI from 'react-appinsights';
import { IntlProvider } from 'react-intl';
import { NotificationContainer } from 'react-notifications';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ApprovalRoutes from '../pages/approvals';
import InventoryItemRoutes from '../pages/inventory-items';
import OrderDocumentRoutes from '../pages/order-documents';

const history = createBrowserHistory();
if (
  process.env.NX_REACT_APP_APP_INSIGHTS_KEY &&
  process.env.NX_REACT_APP_APP_INSIGHTS_KEY !== ''
) {
  ReactAI.init(
    { instrumentationKey: process.env.NX_REACT_APP_APP_INSIGHTS_KEY },
    history
  );
}

export function CustomerInventoryApp({hasUnsavedChangesChanged, injector}) {
  return (
    <IntlProvider locale="en">
      <HasUnsavedChangesProvider hasUnsavedChangesChanged = {hasUnsavedChangesChanged}>
        <InjectorProvider injector = {injector}>
          <BrowserRouter>
            <Fragment>
              <NotificationContainer />
              <Switch>
                <Route path="/inventory" component={InventoryItemRoutes} />
                <Route component={NotFound} />
              </Switch>
            </Fragment>
          </BrowserRouter>
        </InjectorProvider>
      </HasUnsavedChangesProvider>
    </IntlProvider>
  );
}

export function CustomerDocumentsApp({hasUnsavedChangesChanged, injector}) {
  return (
    <IntlProvider locale="en">
      <HasUnsavedChangesProvider hasUnsavedChangesChanged = {hasUnsavedChangesChanged}>
        <InjectorProvider injector = {injector}>
          <BrowserRouter>
            <Fragment>
              <NotificationContainer />
              <Switch>
                <Route path="/documents" component={OrderDocumentRoutes} />
                <Route component={NotFound} />
              </Switch>
            </Fragment>
          </BrowserRouter>
        </InjectorProvider>
      </HasUnsavedChangesProvider>
    </IntlProvider>
  );
}

export function CustomerApprovalsApp({hasUnsavedChangesChanged, injector}) {
  return (
    <IntlProvider locale="en">
      <HasUnsavedChangesProvider hasUnsavedChangesChanged = {hasUnsavedChangesChanged}>
        <InjectorProvider injector = {injector}>
          <BrowserRouter>
            <Fragment>
              <NotificationContainer />
              <Switch>
                <Route path="/approvals" component={ApprovalRoutes} />
                <Route component={NotFound} />
              </Switch>
            </Fragment>
          </BrowserRouter>
        </InjectorProvider>
      </HasUnsavedChangesProvider>
    </IntlProvider>
  );
}
